import { Customer } from './customer';
import { api } from './index';
import { QueryOptions } from './product';
import { ProductWeight } from './productWeight';

// Bill interfaces
export interface Bill {
  id: string;
  officialCode?: string;
  officialDate?: Date;
  remark?: string;
  balance: number;
  taxBalance: number;
  customer: Customer;
  productWeights: ProductWeight[];
}

export interface BillCreateDTO {
  officialCode?: string;
  officialDate?: Date;
  remark?: string;
  balance: number;
  taxBalance: number;
  customerId: string;
  productWeights: [{id: string}];
}

export interface BillUpdateDTO {
  officialCode?: string;
  officialDate?: Date;
  remark?: string;
  balance?: number;
  taxBalance?: number;
  productWeights: [{id: string}];
}

export interface WhereQuery {
  where: string;
  params: Record<string, any>;
}

// Response interfaces
export interface ListResponse<T> {
  statusCode: number;
  data: T[];
  totalCount: number;
}

export interface SingleResponse<T> {
  statusCode: number;
  data: T;
}

// Bill service
export const billService = {
  /**
   * List all bills with optional pagination and sorting
   */
  list: (options?: QueryOptions) =>
    api.get<ListResponse<Bill>>('/bill', { params: options }),

  where: (whereData: WhereQuery, options?: QueryOptions) =>
    api.post<ListResponse<Bill>>('/bill/where', whereData, { 
      params: options 
    }),

  /**
   * Get a single bill by ID
   */
  read: (id: string, options?: Pick<QueryOptions, 'view' | 'additional'>) =>
    api.get<SingleResponse<Bill>>(`/bill/${id}`, { 
      params: options 
    }),

  /**
   * Create a new bill
   */
  create: (data: BillCreateDTO) =>
    api.post<SingleResponse<Bill>>('/bill', data),

  /**
   * Update an existing bill
   */
  update: (id: string, data: BillUpdateDTO) =>
    api.put<SingleResponse<Bill>>(`/bill/${id}`, data),

  /**
   * Delete a bill
   */
  delete: (id: string) =>
    api.delete<{ statusCode: number }>(`/bill/${id}`),
}; 